//
//
//
//
//
//
//
//
//
//
//
//

import {
  getSStore,
  getRoutePage,
  hashQuery,
  setRoutePage
} from "@js/public/mUtils";

export default {
  components: {},
  methods: {},
  created() {
    const fundCode = hashQuery("fundCode") || "";
    let routePage = "/comeIn/money/all";
    if (fundCode) {
      routePage = `/productDetail?fundCode=${fundCode}`;
    }
    setRoutePage(routePage);
    this.timer = setInterval(() => {
      --this.time;
      if (this.time === 0) {
        clearInterval(this.timer);
        this.toRoutePage();
      }
    }, 1000);
  },
  data() {
    return {
      time: 3,
      timer: null
    };
  },
  methods: {
    toRoutePage() {
      const routePage = getRoutePage();
      if (getSStore("token")) {
        this.toPage(routePage);
      } else {
        this.toPage("/");
      }
    }
  },
  destroyed() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  }
};



// WEBPACK FOOTER //
// ./src/components/launch.vue